import { useDispatch, useSelector } from 'react-redux';
import './css/app.css'
import './css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';
import bank from './bankList'

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from './component/btn/btn';
import List from './component/list/list';
// import TreeList from './component/list/treeList';

import { LoadingModal } from './component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { ChevronDown, FileX } from 'lucide-react';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from './component/search/search';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import useWindowSize from './hook/useWindowSize'
import html2canvas from 'html2canvas';

function IntegrateAgentMobile() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const MyData = useSelector((state) => state.MyData);

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    // 트리 전체(계층형)
    const [listData, setListData] = useState([]);
    // 검색/토글/접기/펴기로 현재 화면에 표시 중인 트리
    const [filterTreeData, setFilterTreeData] = useState([]);
    // 테이블(1차원) 형태
    const [combineData, setCombineData] = useState([]);
    // 총 에이전트 수
    const [agentLength, setAgentLength] = useState(0);

    // 예: 모달
    const [createModal, setCreateModal] = useState(true);
    const [updateModal, setUpdataeModal] = useState(false);
    const [clickData, setClickData] = useState(null);

    // 날짜
    const inputRef = useRef(null);
    const pickerRef = useRef(null);
    const [preDate, setPreDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [nextDate, setNextDate] = useState(dayjs().format("YYYY-MM-DD"));

    // 검색
    const select3 = ["에이전트명", "에이전트아이디"];
    const [selectedValue2, setSelectedValue2] = useState("에이전트명");
    const [selectedText4, setSelectText4] = useState("");

    // 리렌더 트리거
    const [reload, setReload] = useState(false);
    const [listState, setListState] = useState(false);

    const [detailModal, setDetailModal] = useState(false)

    // ─────────────────────────────────────────────────────────
    // 1) 초기 설정: 헤더 & 날짜피커
    // ─────────────────────────────────────────────────────────
    useEffect(() => {
        dispatch(change_Current_Location("통합에이전트"));
        dispatch(
            changeHeaderTitle({
                mainTitle: "에이전트관리",
                subTitle: "통합에이전트",
            })
        );

        if (MyData?.role == "SUPER") {
            // Litepicker
            pickerRef.current = new Litepicker({
                element: inputRef.current,
                lang: "ko",
                singleMode: false,
                format: "YYYY-MM-DD",
                numberOfMonths: 2,
                numberOfColumns: 2,
                showWeekNumbers: true,
                dropdowns: {
                    minYear: 2020,
                    maxYear: 2030,
                    months: true,
                    years: true,
                },
                setup: (picker) => {
                    picker.on("selected", (start, end) => {
                        setPreDate(start.format("YYYY-MM-DD"));
                        setNextDate(end.format("YYYY-MM-DD"));
                    });
                },
            });

            setDateRange(dayjs().format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD"));
            setTimeout(() => setLoading(false), 500);

            return () => {
                pickerRef.current?.destroy();
            };
        }
        // eslint-disable-next-line
    }, []);

    const setDateRange = (start, end) => {
        setPreDate(start);
        setNextDate(end);
        pickerRef.current?.setDateRange(start, end);
        onSubmitSearch();
    };

    // 검색버튼
    const onSubmitSearch = () => {
        setReload((prev) => !prev);
        setClickData(null);
    };

    // ─────────────────────────────────────────────────────────
    // 2) 예시: 목업 데이터 (서버 대신)
    // ─────────────────────────────────────────────────────────
    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            // 목업 계층형 데이터
            const data = mockTreeData();
            const init = initTreeData(data, 1, null);
            setListData(init);
            setAgentLength(6); // 예: 6명
            setLoading(false);
        }, 800);
    }, [reload]);

    // 예시 목업 트리
    function mockTreeData() {
        return [
            {
                id: 1,
                nm: "지사 A",
                agent_id: "branchA",
                children: [
                    {
                        id: 2,
                        nm: "총판 A1",
                        agent_id: "dealerA1",
                        children: [
                            {
                                id: 3,
                                nm: "대리점 A1-1",
                                agent_id: "agentA11",
                                detailData: [
                                    { storeName: "가맹점1", amount: "10,000원" },
                                    { storeName: "가맹점2", amount: "25,000원" },
                                ],
                                children: [],
                            },
                            {
                                id: 4,
                                nm: "대리점 A1-2",
                                agent_id: "agentA12",
                                detailData: [
                                    { storeName: "가맹점3", amount: "50,000원" },
                                    { storeName: "가맹점4", amount: "15,000원" },
                                ],
                                children: [],
                            },
                        ],
                    },
                ],
            },
            {
                id: 5,
                nm: "지사 B",
                agent_id: "branchB",
                children: [
                    {
                        id: 6,
                        nm: "총판 B1",
                        agent_id: "dealerB1",
                        detailData: [
                            { storeName: "B1 직영 가맹점", amount: "70,000원" },
                        ],
                        children: [],
                    },
                ],
            },
        ];
    }

    // 부모/자식/level 설정 + detailOpen=false
    function initTreeData(arr, level, parent) {
        return arr.map((item) => {
            const newItem = {
                ...item,
                _expanded: false,   // 트리(자식) 열림 여부
                _detailOpen: false, // 가맹점 표 열림 여부
                _level: level,
                parent: parent || null,
            };
            if (item.children && item.children.length > 0) {
                newItem.children = initTreeData(item.children, level + 1, newItem);
            } else {
                newItem.children = [];
            }
            return newItem;
        });
    }

    // ─────────────────────────────────────────────────────────
    // 검색 로직 (부모+자식)
    // ─────────────────────────────────────────────────────────
    useEffect(() => {
        const keyword = selectedText4.trim();

        if (!keyword) {
            const closedAll = closeAllExpanded(listData);
            setFilterTreeData(closedAll);
            return;
        }

        const allNodes = [];
        flattenTreeAll(listData, allNodes);

        const matchedSet = new Set();
        for (const node of allNodes) {
            const nmMatch =
                node.nm && node.nm.toLowerCase().includes(keyword.toLowerCase());
            const idMatch =
                node.agent_id &&
                node.agent_id.toLowerCase().includes(keyword.toLowerCase());
            if (nmMatch || idMatch) {
                addAncestors(node, matchedSet);
                addDescendants(node, matchedSet);
            }
        }

        const filteredTree = keepNodeAndAllChildren(listData, matchedSet);
        const openedAll = openAllExpanded(filteredTree);
        setFilterTreeData(openedAll);
    }, [listData, selectedText4]);

    function flattenTreeAll(nodes, output) {
        for (const node of nodes) {
            output.push(node);
            if (node.children && node.children.length) {
                flattenTreeAll(node.children, output);
            }
        }
    }
    function addAncestors(node, matchedSet) {
        let cur = node;
        while (cur) {
            matchedSet.add(cur);
            cur = cur.parent;
        }
    }
    function addDescendants(node, matchedSet) {
        matchedSet.add(node);
        if (!node.children || node.children.length === 0) return;
        for (const c of node.children) {
            addDescendants(c, matchedSet);
        }
    }
    function keepNodeAndAllChildren(originalNodes, matchedSet) {
        const result = [];
        for (const node of originalNodes) {
            if (matchedSet.has(node)) {
                const newNode = { ...node };
                newNode.children = keepNodeAndAllChildren(node.children, matchedSet);
                result.push(newNode);
            } else {
                const filteredChildren = keepNodeAndAllChildren(node.children, matchedSet);
                if (filteredChildren.length > 0) {
                    const newNode = { ...node };
                    newNode.children = filteredChildren;
                    result.push(newNode);
                }
            }
        }
        return result;
    }

    // ─────────────────────────────────────────────────────────
    // filterTreeData -> flatten -> combineData
    // ─────────────────────────────────────────────────────────
    useEffect(() => {
        if (!filterTreeData || filterTreeData.length === 0) {
            setCombineData([]);
            return;
        }
        const flat = [];
        flattenTree(filterTreeData, flat);
        setCombineData(buildTableRowArray(flat));
    }, [filterTreeData]);

    // 펼쳐진 노드만 flatten
    function flattenTree(nodes, output, ancestors = []) {
        nodes.forEach((node, idx) => {
            const isLastChild = idx === nodes.length - 1;
            node._ancestorLastChild = ancestors;
            node._isLastChild = isLastChild;

            output.push(node);

            if (node._expanded && node.children && node.children.length) {
                flattenTree(node.children, output, [...ancestors, isLastChild]);
            }
        });
    }

    // ─────────────────────────────────────────────────────────
    // 아이콘 클릭 => node._expanded 토글 (트리)
    // ─────────────────────────────────────────────────────────
    function handleIconClick(e, node) {
        e.stopPropagation();
        setFilterTreeData((prev) => toggleExpandedInTree(prev, node.id));
    }
    function toggleExpandedInTree(dataArr, targetId) {
        return dataArr.map((item) => {
            if (item.id === targetId) {
                return { ...item, _expanded: !item._expanded };
            }
            if (item.children && item.children.length > 0) {
                return {
                    ...item,
                    children: toggleExpandedInTree(item.children, targetId),
                };
            }
            return { ...item };
        });
    }

    // ─────────────────────────────────────────────────────────
    // 가맹점 표 열기/닫기 => node._detailOpen
    // ─────────────────────────────────────────────────────────
    function toggleDetailDropdown(e, node) {
        e.stopPropagation();

        // 1) 자신이 닫혀있으면 => 닫아둔 다른 노드 모두 false, 자신만 열기
        // 2) 자신이 열려있으면 => 그냥 닫기
        const wantOpen = !node._detailOpen; // true=>열고싶은, false=>닫고싶은
        setFilterTreeData((prev) => closeAllDetail(prev)); // 우선 전부 닫음
        if (wantOpen) {
            // 자신을 열기
            setFilterTreeData((prev) => toggleDetailInTree(prev, node.id));
        }
    }

    // 전부 detailOpen = false
    function closeAllDetail(dataArr) {
        return dataArr.map((item) => {
            let tmp = { ...item, _detailOpen: false };
            if (item.children && item.children.length > 0) {
                tmp.children = closeAllDetail(item.children);
            }
            return tmp;
        });
    }

    function toggleDetailInTree(dataArr, targetId) {
        return dataArr.map((item) => {
            if (item.id === targetId) {
                return { ...item, _detailOpen: !item._detailOpen };
            }
            if (item.children && item.children.length > 0) {
                return {
                    ...item,
                    children: toggleDetailInTree(item.children, targetId),
                };
            }
            return { ...item };
        });
    }

    // ─────────────────────────────────────────────────────────
    // (★) 테이블 rowData 생성 + isOpen(배경색) 설정
    // ─────────────────────────────────────────────────────────
    function buildTableRowArray(flatData) {
        let tableBodyData = [];

        for (let i = 0; i < flatData.length; i++) {
            const node = flatData[i];

            // 세로줄 아이콘
            const depthLines = (node._ancestorLastChild ?? []).map((isAncestorLast) =>
                isAncestorLast
                    ? "/img/icon/ftv2blank.gif"
                    : "/img/icon/ftv2vertline.gif"
            );

            // + / - 아이콘
            let iconSrc = "/img/icon/ftv2node.gif";
            if (node.children && node.children.length > 0) {
                if (node._expanded) {
                    iconSrc = node._isLastChild
                        ? "/img/icon/ftv2plastmnode.png"
                        : "/img/icon/ftv2mnode.gif";
                } else {
                    iconSrc = node._isLastChild
                        ? "/img/icon/ftv2plastnode.gif"
                        : "/img/icon/ftv2pnode.gif";
                }
            } else {
                iconSrc = node._isLastChild
                    ? "/img/icon/ftv2lastnode.gif"
                    : "/img/icon/ftv2node.gif";
            }
            depthLines.push(iconSrc);

            // 아이콘 배열
            const iconElements = depthLines.map((src, idx) => {
                const isLastIcon = idx === depthLines.length - 1;
                if (isLastIcon && node.children && node.children.length > 0) {
                    return (
                        <img
                            key={idx}
                            src={src}
                            alt=""
                            style={{ height: "38px", boxShadow: "none", cursor: "pointer" }}
                            onClick={(e) => handleIconClick(e, node)}
                        />
                    );
                } else {
                    return (
                        <img
                            key={idx}
                            src={src}
                            alt=""
                            style={{ height: "38px", boxShadow: "none" }}
                        />
                    );
                }
            });

            // 두 번째 열(아이디) + 드롭다운 버튼
            const detailBtn = node.detailData && node.detailData.length > 0 && (
                <button
                    style={{
                        background: "none",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        cursor: "pointer",
                        padding: "1px 4px",
                        fontSize: "12px",
                    }}
                    onClick={(e) => toggleDetailDropdown(e, node)}
                >
                    {node._detailOpen ? "▲" : "▼"}
                </button>
            );

            // 첫 열(에이전트명)
            const agentNameCell = (
                <div
                    style={{
                        position: "absolute",
                        top: "50%",
                        transform: "translateY(-50%)",
                        left: "10px",
                        height: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        width: "calc(100% - 10px)"
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {iconElements}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                paddingLeft: "3px",
                            }}
                        >
                            {node.nm}
                            {node?.children?.length > 0 ? `(${node?.children?.length})` : ""}
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            paddingRight: "10px"
                        }}
                    >
                        {detailBtn}
                    </div>
                </div>
            );

            const agentIdCell = (
                <div
                    style={{
                        position: "absolute",
                        top: "50%",
                        transform: "translate(-50%, -50%)",
                        left: "50%",
                        height: "100%",
                        display: "flex",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {node.agent_id}
                    </div>
                </div>
            );

            // 메인 행
            const rowData = [
                {
                    no: 1,
                    text: agentNameCell,
                    width: "200px",
                    textAlign: "left",
                },
                {
                    no: 2,
                    text: agentIdCell,
                    width: "100px",
                    textAlign: "center",
                },
            ];
            // ★ isOpen을 세팅 (=> Listbody에서 rowArr.isOpen으로 접근)
            rowData.id = node.id;
            rowData.isOpen = node._detailOpen; // or node._expanded, if you want

            tableBodyData.push(rowData);

            // 가맹점 표 드롭다운
            if (node._detailOpen && node.detailData && node.detailData.length > 0) {
                tableBodyData.push([
                    {
                        no: 99,
                        colSpan: 2,
                        text: (
                            <div style={{ padding: "0", margin: "0" }}>
                                <table
                                    style={{
                                        width: "100%",
                                        borderCollapse: "collapse",
                                        border: "1px solid #e7eaf3",
                                    }}
                                >
                                    <thead>
                                        <tr style={{ background: "#fafafa", height: "30px" }}>
                                            <th
                                                style={{
                                                    border: "1px solid #e7eaf3",
                                                    padding: "5px",
                                                    width: "40%",
                                                    textAlign: "center",
                                                }}
                                            >
                                                가맹점명
                                            </th>
                                            <th
                                                style={{
                                                    border: "1px solid #e7eaf3",
                                                    padding: "5px",
                                                    width: "40%",
                                                    textAlign: "center",
                                                }}
                                            >
                                                매출
                                            </th>
                                            <th
                                                style={{
                                                    border: "1px solid #e7eaf3",
                                                    padding: "5px",
                                                    width: "20%",
                                                    textAlign: "center",
                                                }}
                                            >
                                                상세
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {node.detailData.map((item, idx2) => (
                                            <tr key={idx2} style={{ height: "30px" }}>
                                                <td
                                                    style={{
                                                        border: "1px solid #e7eaf3",
                                                        padding: "5px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {item.storeName}
                                                </td>
                                                <td
                                                    style={{
                                                        border: "1px solid #e7eaf3",
                                                        padding: "5px",
                                                        textAlign: "right",
                                                    }}
                                                >
                                                    {item.amount}
                                                </td>
                                                <td
                                                    style={{
                                                        border: "1px solid #e7eaf3",
                                                        padding: "5px",
                                                        textAlign: "center",
                                                        cursor: "pointer",
                                                        color: '#0a6e0a',
                                                        // display: 'flex',
                                                        // alignItems: 'center',
                                                        // justifyContent: "center"
                                                    }}
                                                    onClick={() => setDetailModal(true)}
                                                >
                                                    상세
                                                    {/* <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        className="lucide lucide-clipboard w-4 h-4"
                                                    >
                                                        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                                                        <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                                                    </svg> */}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ),
                    },
                ]);
            }
        }

        return tableBodyData;
    }

    // 행 클릭 => clickData
    function handleRowClick(row) {
        const foundNode = findNodeById(filterTreeData, row.id);
        if (foundNode) {
            setClickData(foundNode);
            setCreateModal(false);
            setUpdataeModal(true);
        }
        setListState((e) => !e);
    }

    function findNodeById(dataArr, targetId) {
        for (let item of dataArr) {
            if (item.id === targetId) return item;
            if (item.children && item.children.length > 0) {
                const result = findNodeById(item.children, targetId);
                if (result) return result;
            }
        }
        return null;
    }

    // 전체 펴기 / 접기
    function openAllExpanded(arr) {
        return arr.map((item) => ({
            ...item,
            _expanded: true,
            children: item.children ? openAllExpanded(item.children) : [],
        }));
    }
    function closeAllExpanded(arr) {
        return arr.map((item) => ({
            ...item,
            _expanded: false,
            children: item.children ? closeAllExpanded(item.children) : [],
        }));
    }
    const handleOpenAll = () => {
        setFilterTreeData((prev) => openAllExpanded(prev));
        setListState((e) => !e);
    };
    const handleCloseAll = () => {
        setFilterTreeData((prev) => closeAllExpanded(prev));
        setListState((e) => !e);
    };

    // 테이블 헤더
    const tableHeaderData = [
        { no: 1, text: "에이전트명", width: "200px", textAlign: "center" },
        { no: 2, text: "아이디", width: "100px", textAlign: "center" },
    ];

    return (
        <div className="content" id="contents">
            {loading && <LoadingModal />}
            <MessageModal message={message} />
            {detailModal && (<MobileDetailModal setModal={setDetailModal} />)}

            {/* 검색/필터 폼 */}
            {
                MyData?.role == "SUPER"
                    ?
                    <div className="form_filter intro-y">
                        <form
                            id="tabulator-html-filter-form"
                            style={{ display: "flex", alignItems: "center" }}
                        >
                            <SearchDate
                                type={"기간"}
                                inputRef={inputRef}
                                setDateRange={setDateRange}
                                preDate={preDate}
                                nextDate={nextDate}
                                isDisabled={true}
                            />
                            <SearchSelectText
                                type={"검색구분"}
                                selectData={select3}
                                handleSelectChange={(e) => setSelectedValue2(e.target.value)}
                                selectedValue={selectedValue2}
                                handleSelectTextChange={(e) => setSelectText4(e.target.value)}
                                selectedText={selectedText4}
                                btnText={"검색"}
                                placeholder={"에이전트명 & 아이디"}
                                onClick={onSubmitSearch}
                                state={false}
                            />
                        </form>
                    </div>
                    :
                    ""
            }

            <div
                className="intro-y box intro-padding"
                style={{
                    overflowY: "auto",
                    height: MyData?.role == "SUPER" ? "calc(100dvh - 10rem)" : "calc(100dvh - 6rem)",
                }}
            >
                <div className="div-flex-2">
                    {/* 좌측: 트리 테이블 */}
                    <div style={{ maxWidth: "400px", width: "100%" }}>
                        <div
                            className="tabulator_sorting_wrap"
                            style={{
                                flexDirection: "row",
                                marginBottom: "8px",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <CountAmountLeft tableBodyData={agentLength} />
                            <div style={{ display: "flex", gap: "10px" }}>
                                <button
                                    type="button"
                                    className="btn btn-primary modal_btn btn_small"
                                    onClick={handleOpenAll}
                                    style={{ height: "30px", fontSize: "12px" }}
                                >
                                    펴기
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary modal_btn btn_small"
                                    onClick={handleCloseAll}
                                    style={{ height: "30px", fontSize: "12px" }}
                                >
                                    접기
                                </button>
                            </div>
                        </div>

                        {/* 트리 렌더 */}
                        <TreeList
                            tableHeaderData={tableHeaderData}
                            tableBodyData={filterTreeData ?? []}
                            filter_tableBodyData={combineData}
                            clickData={clickData}
                            onRowClick={handleRowClick}
                            listState={listState}
                            nonePage={false}
                            height={"calc(100dvh - 12rem)"}
                            scrollState={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

function TreeList({
    tableHeaderData,
    tableBodyData,
    filter_tableBodyData = [],
    page,
    setPage,
    maxFirstPage,
    onInputChange,
    height,
    nonePage = true,

    // 체크박스 관련
    checkedRows = [],
    onCheckboxChange = () => { },

    clickData,
    onRowClick,
    listType = false,
    listState = false,
    scrollState = false,
}) {
    const widthRef = useRef();
    const [Width, setWidth] = useState("0");
    const [tableWidth, setTableWidth] = useState("0");
    const [extraWidth, setExtraWidth] = useState(0);

    // 스크롤 여부 체크용
    const [isScrollable, setIsScrollable] = useState(false);
    const [atBottom, setAtBottom] = useState(false);

    // (1) 윈도우 리사이즈
    useEffect(() => {
        const handleResize = () => {
            if (widthRef.current) {
                setWidth(`${widthRef.current.offsetWidth}`);
            }
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // (2) 테이블 폭 계산
    useEffect(() => {
        if (
            Width !== "0" &&
            tableWidth !== "0" &&
            !isNaN(Width) &&
            !isNaN(tableWidth)
        ) {
            if (Number(Width) > Number(tableWidth)) {
                setExtraWidth(
                    (Number(Width) - Number(tableWidth)) / tableHeaderData.length
                );
            } else {
                setExtraWidth(0);
            }
        }
    }, [Width, tableWidth, tableHeaderData]);

    // (4) 스크롤 가능 여부
    useEffect(() => {
        if (widthRef.current) {
            const el = widthRef.current;
            if (el.scrollHeight > el.clientHeight) {
                setIsScrollable(true);
            } else {
                setIsScrollable(false);
            }
        }
    }, [filter_tableBodyData, tableBodyData]);

    // (5) 맨 아래 스크롤 이벤트
    useEffect(() => {
        const el = widthRef.current;
        if (!el) return;
        const handleScroll = () => {
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 1) {
                setAtBottom(true);
            } else {
                setAtBottom(false);
            }
        };
        el.addEventListener("scroll", handleScroll);
        return () => el.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div className="overflow-x-auto scrollbar-hidden relative">
            <div
                id="tabulator2"
                className="mt-3 table-report table-report--tabulator payList tabulator"
                role="grid"
                tabulator-layout="fitColumns"
                style={{ height: height ? height : "" }}
            >
                <div className="tabulator-tableHolder relative" ref={widthRef}>
                    <Listheader
                        tableHeaderData={tableHeaderData}
                        Width={Width}
                        extraWidth={extraWidth}
                        tableWidth={tableWidth}
                        setTableWidth={setTableWidth}
                    />
                    <Listbody
                        filter_tableBodyData={filter_tableBodyData}
                        extraWidth={extraWidth}
                        onInputChange={onInputChange}
                        checkedRows={checkedRows}
                        onCheckboxChange={onCheckboxChange}
                        selectedData={clickData}
                        onRowClick={onRowClick}
                    />
                </div>

                {isScrollable && !atBottom && scrollState && (
                    <div
                        className="absolute left-1/2 transform -translate-x-1/2 flex flex-col items-center"
                        style={{ bottom: "30px" }}
                    >
                        <ChevronDown
                            className="text-gray-400 text-2xl animate-bounce"
                            size={30}
                            style={{ color: "#000" }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

function Listheader({ tableHeaderData, Width, extraWidth, tableWidth, setTableWidth }) {
    const ref = useRef();

    useEffect(() => {
        if (ref.current) {
            setTableWidth(`${ref.current.offsetWidth}` ?? '100%');
        }
    }, [setTableWidth]);

    const containerWidth = Number(Width) > Number(tableWidth) ? Width : tableWidth;

    return (
        <div
            className="tabulator-header"
            tabIndex="0"
            style={{
                paddingRight: '0px',
                marginLeft: '0px',
                width: `${containerWidth}px`,
            }}
        >
            <div
                className="tabulator-headers tabulator-table"
                style={{ marginLeft: '0px' }}
                ref={ref}
            >
                {tableHeaderData.map((a, i) => (
                    <TableHeaderList key={i} item={a} extraWidth={extraWidth} />
                ))}
            </div>
        </div>
    );
}

function TableHeaderList({ item, extraWidth }) {
    let wid = item?.width?.split('px');
    const calcWidth = wid?.[0] ? Number(wid[0]) + extraWidth : 100;

    return (
        <div
            className="tabulator-col tabulator-sortable"
            role="columnheader"
            aria-sort="none"
            style={{
                minWidth: calcWidth + 'px',
                width: calcWidth + 'px',
            }}
        >
            <div className="tabulator-col-content">
                <div className="tabulator-col-title-holder">
                    <div
                        className="tabulator-col-title"
                        style={{ textAlign: item?.textAlign ?? 'center' }}
                    >
                        {item?.text ?? ''}
                    </div>
                    <div className="tabulator-col-sorter">
                        <div className="tabulator-arrow"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function Listbody({
    filter_tableBodyData = [],
    extraWidth,
    onInputChange,
    // 체크박스
    checkedRows,
    onCheckboxChange,
    selectedData,
    onRowClick,
}) {
    if (!filter_tableBodyData.length) {
        return (
            <div
                tabIndex="0"
                style={{
                    minHeight: 'calc(100% - 84px)',
                    height: 'auto',
                    maxHeight: 'calc(100% - 84px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <div
                    style={{
                        color: '#666',
                        margin: '70px 0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        flexDirection: 'column',
                    }}
                >
                    <p>리스트가 없습니다.</p>
                </div>
            </div>
        );
    }

    return (
        <div
            tabIndex="0"
            style={{
                minHeight: 'calc(100% - 84px)',
                height: 'auto',
                maxHeight: 'calc(100% - 84px)',
            }}
        >
            <div
                className="tabulator-table"
                style={{ paddingTop: '0px', paddingBottom: '0px', borderBottom: "1px solid #e7eaf3" }}
            >
                {filter_tableBodyData.map((rowArr, rowIndex) => {
                    // (A) 상세행(colSpan)
                    if (rowArr.length === 1 && rowArr[0].colSpan) {
                        return (
                            <div
                                key={rowIndex}
                                className="tabulator-row tabulator-selectable tabulator-row-odd"
                                role="row"
                            >
                                <div
                                    className="tabulator-cell table-overflow-hidden no-padding"
                                    role="gridcell"
                                    style={{
                                        width: '100%',
                                        textAlign: 'center',
                                        height: 'auto',
                                        border: 'none',
                                    }}
                                >
                                    {rowArr[0].text}
                                </div>
                            </div>
                        );
                    }

                    // (B) 일반행
                    let rowStyle = {};
                    let rowClass = 'tabulator-row tabulator-selectable tabulator-row-odd';

                    // “isOpen” true인 경우 배경색
                    if (rowArr.isOpen) {
                        rowStyle.backgroundColor = '#fff4ce';
                    }

                    return (
                        <div
                            key={rowIndex}
                            className={rowClass}
                            role="row"
                            style={{
                                paddingLeft: '0px',
                                cursor: onRowClick ? 'pointer' : 'default',
                                ...rowStyle,
                                borderBottom: "none",
                            }}
                            onClick={() => onRowClick?.(rowArr)}
                        >
                            {rowArr.map((item, cellIndex) => (
                                <TableBodyList
                                    key={cellIndex}
                                    item={item}
                                    extraWidth={extraWidth}
                                    rowIndex={rowIndex}
                                    cellIndex={cellIndex}
                                    onInputChange={onInputChange}
                                    checkedRows={checkedRows}
                                    onCheckboxChange={onCheckboxChange}
                                />
                            ))}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

function TableBodyList({
    item,
    extraWidth,
    rowIndex,
    cellIndex,
    onInputChange,
    // 체크박스
    checkedRows,
    onCheckboxChange,
}) {
    const [isEditing, setIsEditing] = useState(false);
    const [isComposing, setIsComposing] = useState(false);

    let wid = item?.width?.split('px');
    const calcWidth = wid?.[0] ? Number(wid[0]) + extraWidth : 100;

    const commonStyle = {
        width: calcWidth + 'px',
        textAlign: item?.textAlign ?? 'center',
        display: 'inline-flex',
        alignItems: 'flex-start',
        justifyContent:
            item.textAlign === 'left'
                ? 'flex-start'
                : item.textAlign === 'center'
                    ? 'center'
                    : item.textAlign === 'right'
                        ? 'flex-end'
                        : 'center',
        height: '38px',
    };

    // 체크박스 열
    if (item.type === 'checkbox') {
        const isChecked = checkedRows.includes(rowIndex);
        return (
            <div
                className="tabulator-cell table-overflow-hidden"
                role="gridcell"
                style={{ ...commonStyle, justifyContent: 'center' }}
            >
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => onCheckboxChange(rowIndex, e.target.checked)}
                    style={{ border: '1px solid #afafaf' }}
                />
            </div>
        );
    }

    // 편집 가능한 열
    const handleDoubleClick = () => {
        if (item.type === 'editable') {
            setIsEditing(true);
        }
    };
    const handleChange = (e) => {
        if (isComposing) return;
        onInputChange?.(rowIndex, cellIndex, e.target.value);
    };

    if (item.type === 'editable') {
        if (!isEditing) {
            return (
                <div
                    className="tabulator-cell table-overflow-hidden"
                    role="gridcell"
                    style={commonStyle}
                    onDoubleClick={handleDoubleClick}
                >
                    {typeof item?.text === 'string' ? item.text : item.text ?? ''}
                </div>
            );
        } else {
            return (
                <input
                    className="tabulator-cell table-overflow-hidden"
                    role="gridcell"
                    style={{ ...commonStyle, backgroundColor: 'yellow' }}
                    value={typeof item?.text === 'string' ? item.text : ''}
                    onChange={handleChange}
                    onCompositionStart={() => setIsComposing(true)}
                    onCompositionEnd={(e) => {
                        setIsComposing(false);
                        onInputChange?.(rowIndex, cellIndex, e.target.value);
                    }}
                />
            );
        }
    }

    // 일반 텍스트 열
    return (
        <div
            className="tabulator-cell table-overflow-hidden"
            role="gridcell"
            style={commonStyle}
            onDoubleClick={handleDoubleClick}
        >
            {typeof item?.text === 'string' ? item.text : item.text ?? ''}
        </div>
    );
}

function MobileDetailModal({ setModal }) {
    const { Rwidth, Rheight } = useWindowSize(); // 실제 훅 사용 시
    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(20)

    // 테이블 헤더
    const tableHeaderData = [
        { no: 2, text: "날짜", width: "120px", textAlign: "center" },
        { no: 3, text: "금액", width: "100px", textAlign: "center" },
    ];

    // (A) 테이블에 넣을 데이터(총 건수)
    const [combineList, setCombineList] = useState(0);
    // (B) 테이블 실제 행 데이터
    const [combineData, setCombineData] = useState([]);

    // 'monthly' => 일별, 'yearly' => 월별
    const [period, setPeriod] = useState('monthly');

    // =========================
    // 년/월 select 동적 생성
    // =========================
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;

    // 연도 범위: 2024~현재연도
    const yearList = [];
    for (let y = 2024; y <= currentYear; y++) {
        yearList.push(y);
    }

    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);

    // 연도별 Month 리스트
    const getMonthList = () => {
        const monthArray = [];
        const limit = (selectedYear === currentYear) ? currentMonth : 12;
        for (let m = 1; m <= limit; m++) {
            monthArray.push(m);
        }
        return monthArray;
    };
    const monthList = getMonthList();

    // =============================
    // 목업데이터 생성 함수
    // =============================
    function generateMockData() {
        // 1) 만약 period==='yearly' → 1~12월 (or 1~limit) 의 "월" 기반
        // 2) 만약 period==='monthly' → 1~31일 (실제 달별 일수 계산은 생략)

        const result = [];
        if (period === 'yearly') {
            // 예: 1~12월 (단, 올해라면 currentMonth까지만)
            const limit = (selectedYear === currentYear) ? currentMonth : 12;
            for (let month = 1; month <= limit; month++) {
                // 예: "2023-07", 금액 임의
                const dateStr = `${selectedYear}-${String(month).padStart(2, '0')}`;
                const randomAmt = Math.floor(Math.random() * 100000) + 1; // 1~100000
                result.push({ date: dateStr, amount: randomAmt });
            }
        } else {
            // period==='monthly' → 1~31일 (임시로 31일 고정)
            // 실제 달별 일수(28,29,30,31) 계산은 생략
            for (let day = 1; day <= 31; day++) {
                const dateStr = `${selectedYear}-${String(selectedMonth).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                const randomAmt = Math.floor(Math.random() * 100000) + 1;
                result.push({ date: dateStr, amount: randomAmt });
            }
        }
        return result;
    }

    // =============================
    // 목업데이터 → 테이블행 변환
    // =============================
    function transformToTableRows(dataArr) {
        // dataArr: [{date, amount}, ...]
        // => table 행: [ {no:..., text:...}, {no:..., text:...} ]
        const rows = [];
        for (let i = 0; i < dataArr.length; i++) {
            const item = dataArr[i];
            const row = [
                {
                    no: 2,
                    text: item.date,
                    width: "120px",
                    textAlign: "center",
                },
                {
                    no: 3,
                    text: `${item.amount.toLocaleString()}원`,
                    width: "100px",
                    textAlign: "right",
                }
            ];
            rows.push(row);
        }
        return rows;
    }

    // =============================
    // period/year/month 변경 시
    // 목업데이터 갱신
    // =============================
    useEffect(() => {
        const data = generateMockData();       // [{date,amount}, ...]
        setCombineList(data.length);           // 총 건수
        setCombineData(transformToTableRows(data)); // 테이블행
    }, [period, selectedYear, selectedMonth]);

    // 모달 close button
    const handleClose = () => {
        setModal(false);
    };

    return (
        <div id="receipt-modal" className="modal" tabIndex="-1">
            <div className="modal-dialog" style={{ padding: "2rem", maxWidth: "400px" }}>
                <div className="modal-content marginTop30 modal_sty ">
                    <div className="modal-header" style={{ border: "none", padding: "0" }}>
                        <h2 className="font-medium text-base mr-auto modal_title_sty">가맹점A 매출 정보</h2>
                        <button
                            className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty"
                            onClick={handleClose}
                        >
                            <span className="w-4 h-4 flex items-center justify-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-plus w-4 h-4"
                                >
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </span>
                        </button>
                    </div>

                    {/* 라디오 & 셀렉트 영역 */}
                    <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <label style={{ marginRight: 5, display: 'flex', alignItems: 'center' }}>
                                    <input
                                        type="radio"
                                        value="monthly"
                                        checked={period === 'monthly'}
                                        onChange={(e) => setPeriod(e.target.value)}
                                    />
                                    <span style={{ marginLeft: 3 }}>월별</span>
                                </label>
                                <label style={{ marginRight: 5, display: 'flex', alignItems: 'center' }}>
                                    <input
                                        type="radio"
                                        value="yearly"
                                        checked={period === 'yearly'}
                                        onChange={(e) => setPeriod(e.target.value)}
                                    />
                                    <span style={{ marginLeft: 3 }}>연도별</span>
                                </label>
                            </div>

                            {/* 년도 + 월 셀렉트 */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                {/* 연도 셀렉트 */}
                                <select
                                    className="form-select"
                                    style={{ height: '30px', padding: '0 10px', fontSize: '12px', width: '70px' }}
                                    value={selectedYear}
                                    onChange={(e) => {
                                        const newYear = parseInt(e.target.value, 10);
                                        setSelectedYear(newYear);
                                        if (newYear < currentYear && selectedMonth > 12) {
                                            setSelectedMonth(12);
                                        }
                                    }}
                                >
                                    {yearList.slice().reverse().map((y) => (
                                        <option key={y} value={y}>
                                            {String(y).substring(2)}년
                                        </option>
                                    ))}
                                </select>

                                {/* 월 셀렉트 (period===monthly 일 때만 표시) */}
                                {period === 'monthly' && (
                                    <select
                                        className="form-select"
                                        style={{ height: '30px', padding: '0 10px', fontSize: '12px', width: '70px' }}
                                        value={selectedMonth}
                                        onChange={(e) => setSelectedMonth(parseInt(e.target.value, 10))}
                                    >
                                        {monthList.slice().reverse().map((m) => (
                                            <option key={m} value={m}>
                                                {m}월
                                            </option>
                                        ))}
                                    </select>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* 테이블 영역 */}
                    <div style={{ maxWidth: "300px", width: "100%", margin: '0 auto' }}>
                        {/* List 컴포넌트 예시 */}
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={combineList}           // 전체 건수
                            filter_tableBodyData={combineData}    // 실제 행 데이터
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            nonePage={false}
                            height={"350px"}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default IntegrateAgentMobile